import { Decoder, array, date, field, string, succeed } from 'jsonous';
import { resourceDecoder } from '../../../../Resource/Decoders';
import { Resource } from '../../../../Resource/Types';

interface RecentActivityPayload {
  createdAt: Date;
  userName: string;
  contentHtml: string;
}

export type RecentActivityResource = Resource<RecentActivityPayload>;

export type RecentActivitiesResource = Resource<RecentActivityResource[]>;

const recentActivityPayloadDecoder: Decoder<RecentActivityPayload> = succeed({})
  .assign('createdAt', field('created_at', date))
  .assign('userName', field('user_name', string))
  .assign('contentHtml', field('content_html', string));

export const recentActivityResourceDecoder: Decoder<RecentActivityResource> = resourceDecoder(
  recentActivityPayloadDecoder,
);

export const recentActivitiesResourceDecoder: Decoder<RecentActivitiesResource> = resourceDecoder(
  array(recentActivityResourceDecoder),
);
